/* PYKAS FUDDER-QUIZ (PetLab-Health-Quiz-Struktur)
   Schritte: Name -> Gewaesser -> Rhythmus -> 4 Kategorien -> Newsletter (optional) -> Report.
   Personalisierung: [gewaesser] in allen Texten wird durch die Eingabe ersetzt.
   Keine Datenspeicherung ohne Zutun — der Newsletter-Schritt ist ueberspringbar (DSGVO).
   Scoring: Sorten-Karten tragen data-passt-* Flags; Treffer + Boost ergeben die Reihenfolge. */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-pykas-quiz]').forEach(initQuiz);
  });

  function geld(cents) {
    try {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
      }).format(cents / 100);
    } catch (fehler) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function initQuiz(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-step]'));
    if (!steps.length) return;

    var bar = root.querySelector('[data-quiz-bar]');
    var zurueck = root.querySelector('[data-quiz-back]');
    var antworten = {};
    var aktuell = 0;

    /* ---------- Personalisierung ---------- */
    function personalisieren() {
      var name = antworten.name || 'deinem Wasser';
      root.querySelectorAll('[data-quiz-personal]').forEach(function (el) {
        if (!el.dataset.quizVorlage) el.dataset.quizVorlage = el.textContent;
        el.textContent = el.dataset.quizVorlage.replace(/\[gewaesser\]/g, name);
      });
    }

    /* ---------- Navigation ---------- */
    // beimStart=true nur fuer den Aufruf nach dem Laden: dort darf weder gescrollt
    // noch der Fokus umgesetzt werden. Sonst springt die Seite beim Oeffnen zum Quiz
    // und nimmt der Tastatur den Einstiegspunkt weg.
    function zeige(index, beimStart) {
      aktuell = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach(function (step, i) { step.hidden = i !== aktuell; });
      if (bar) {
        var anteil = ((aktuell + 1) / steps.length) * 100;
        bar.style.width = anteil + '%';
        bar.parentNode.setAttribute('aria-valuenow', Math.round(anteil));
      }
      if (zurueck) zurueck.hidden = aktuell === 0;
      if (!beimStart) {
        var titel = steps[aktuell].querySelector('[data-quiz-fokus]');
        if (titel) { titel.setAttribute('tabindex', '-1'); titel.focus({ preventScroll: true }); }
        root.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
      pruefeWeiter();
    }

    function pruefeWeiter() {
      var step = steps[aktuell];
      var knopf = step.querySelector('[data-quiz-next]');
      if (!knopf) return;
      var noetig = (step.dataset.quizRequired || '').split(',').filter(Boolean);
      var fertig = noetig.every(function (key) {
        var wert = antworten[key];
        return Array.isArray(wert) ? wert.length > 0 : !!wert;
      });
      knopf.disabled = !fertig;
    }

    /* ---------- Eingaben ---------- */
    root.querySelectorAll('[data-quiz-text]').forEach(function (feld) {
      feld.addEventListener('input', function () {
        var wert = feld.value.trim();
        if (wert) { antworten[feld.dataset.quizText] = wert; }
        else { delete antworten[feld.dataset.quizText]; }
        personalisieren();
        pruefeWeiter();
      });
    });

    root.querySelectorAll('[data-quiz-single]').forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        var feld = knopf.dataset.quizSingle;
        var wert = knopf.dataset.quizWert;
        antworten[feld] = wert;
        root.querySelectorAll('[data-quiz-single="' + feld + '"]').forEach(function (b) {
          b.classList.toggle('is-gewaehlt', b === knopf);
          b.setAttribute('aria-pressed', b === knopf ? 'true' : 'false');
        });
        personalisieren();
        pruefeWeiter();
      });
    });

    root.querySelectorAll('[data-quiz-multi]').forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        var feld = knopf.dataset.quizMulti;
        var wert = knopf.dataset.quizWert;
        var liste = antworten[feld] || [];
        var geschwister = root.querySelectorAll('[data-quiz-multi="' + feld + '"]');

        if (wert === 'keins') {
          liste = liste.indexOf('keins') > -1 ? [] : ['keins'];
        } else {
          liste = liste.filter(function (v) { return v !== 'keins'; });
          var pos = liste.indexOf(wert);
          if (pos > -1) { liste.splice(pos, 1); } else { liste.push(wert); }
        }
        antworten[feld] = liste;

        geschwister.forEach(function (b) {
          var an = liste.indexOf(b.dataset.quizWert) > -1;
          b.classList.toggle('is-gewaehlt', an);
          b.setAttribute('aria-pressed', an ? 'true' : 'false');
        });
        pruefeWeiter();
      });
    });

    root.querySelectorAll('[data-quiz-next]').forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        if (aktuell >= steps.length - 2) { bauReport(); }
        zeige(aktuell + 1);
      });
    });
    root.querySelectorAll('[data-quiz-skip]').forEach(function (knopf) {
      knopf.addEventListener('click', function () { bauReport(); zeige(aktuell + 1); });
    });

    /* Newsletter im Hintergrund absenden — ein Seiten-Reload wuerde alle Antworten
       verwerfen und den Report unerreichbar machen. Schlaegt der Versand fehl,
       bekommt der Nutzer die Ansage trotzdem: das Ergebnis haengt nie am Formular. */
    /* Fallback auf das Formular im vorletzten Schritt, falls Shopifys form-Tag
       das data-Attribut nicht ausgibt — sonst wuerde ein echter Submit alles verwerfen. */
    var mailform = root.querySelector('[data-quiz-form]') ||
      (steps.length > 1 ? steps[steps.length - 2].querySelector('form') : null);
    if (mailform) {
      mailform.addEventListener('submit', function (e) {
        e.preventDefault();
        var knopf = mailform.querySelector('[type="submit"]');
        if (knopf) knopf.disabled = true;
        var weiter = function () {
          var hinweis = root.querySelector('[data-quiz-bestaetigung]');
          if (hinweis) hinweis.hidden = false;
          if (knopf) knopf.disabled = false;
          bauReport();
          zeige(aktuell + 1);
        };
        fetch(mailform.action, {
          method: 'POST',
          body: new FormData(mailform),
          headers: { Accept: 'text/html' }
        }).then(weiter, weiter);
      });
    }
    if (zurueck) zurueck.addEventListener('click', function () { zeige(aktuell - 1); });

    var neustart = root.querySelector('[data-quiz-restart]');
    if (neustart) {
      neustart.addEventListener('click', function () {
        Object.keys(antworten).forEach(function (k) { delete antworten[k]; });
        root.querySelectorAll('.is-gewaehlt').forEach(function (b) {
          b.classList.remove('is-gewaehlt');
          b.setAttribute('aria-pressed', 'false');
        });
        root.querySelectorAll('[data-quiz-text]').forEach(function (f) { f.value = ''; });
        personalisieren();
        zeige(0);
      });
    }

    /* ---------- Scoring ----------
       Nur Aussagen, die im Shop gepflegt sind: passt-Flags und Geschmack aus dem Block,
       Bestseller aus dem Produkt-Tag. Die Geschmacksregel ist im Editor abschaltbar. */
    function punkte(karte) {
      var p = parseInt(karte.dataset.boost || '0', 10);
      var typ = antworten.typ;
      if (typ && karte.dataset['passt' + typ.charAt(0).toUpperCase() + typ.slice(1)] === 'true') p += 3;
      // Teich ist ein stehendes Gewaesser wie der See — nur kleiner. Kein
      // einziges Sorten-Flag ist fuer Teich gepflegt; ohne diese Bruecke
      // bekaeme die Teich-Antwort NULL Punkte und die Empfehlung wuerde
      // vom Zufall (Boost/Bestseller) entschieden.
      if (typ === 'teich' && karte.dataset.passtSee === 'true') p += 2;
      if (antworten.ziel === 'futterplatz' && karte.dataset.passtFutterplatz === 'true') p += 3;
      if (antworten.ziel === 'session' && karte.dataset.passtSession === 'true') p += 3;

      // Wer mehrmals die Woche am Wasser ist, kann einen Platz pflegen —
      // wer nur ein paar Mal im Jahr faehrt, braucht Sorten, die sofort
      // arbeiten. Deine eigene Regel: ein Platz entsteht durch Wiederholung.
      if (antworten.rhythmus === 'oft' && karte.dataset.passtFutterplatz === 'true') p += 1;
      if (antworten.rhythmus === 'selten' && karte.dataset.passtSession === 'true') p += 1;

      var wasser = antworten.wasser || [];
      // Starke Stroemung ist DIE Fluss-Eigenschaft — Sorten, die fuer den
      // Fluss positioniert sind (schwere, deftige Profile), passen dort.
      if (wasser.indexOf('stroemung') > -1 && karte.dataset.passtFluss === 'true') p += 2;
      var temperatur = karte.dataset.temperatur;
      if (wasser.indexOf('kalt') > -1 && temperatur === 'kalt') p += 2;
      if (wasser.indexOf('warm') > -1 && temperatur === 'warm') p += 2;
      return p;
    }

    /* Gleichstand: die Sorte mit mehr Bestseller-Produkten gewinnt — eine echte
       Shop-Angabe statt der Reihenfolge im Theme-Editor. */
    function bestseller(karte) {
      return karte.querySelectorAll('[data-produkt][data-bestseller="true"]').length;
    }

    /* ---------- Setup aus den Formen EINER Sorte ---------- */
    function ersteForm(sorteEl, formenListe, vergeben) {
      var formen = (formenListe || '').split(',');
      for (var i = 0; i < formen.length; i++) {
        var form = formen[i].trim();
        if (!form) continue;
        var treffer = sorteEl.querySelectorAll('[data-produkt][data-form="' + form + '"]');
        for (var k = 0; k < treffer.length; k++) {
          if (vergeben.indexOf(treffer[k]) === -1) return treffer[k];
        }
      }
      return null;
    }

    function baueSetup(sorteEl) {
      var behaelter = sorteEl.querySelector('[data-sorte-produkte]');
      if (!behaelter) return;

      var koeder = antworten.koeder || [];
      var wasser = antworten.wasser || [];
      /* Weissfisch, Krebse und ein weich werdender Koeder verlangen dasselbe: mehr Standfestigkeit
         am Haar. Weite Wuerfe verlangen Dichte — Schwimmer haben Auftrieb und wenig Masse. */
      var braucht_hart = ['weissfisch', 'krebse', 'weich'].some(function (k) {
        return koeder.indexOf(k) > -1;
      });
      var haarFormen = braucht_hart ? root.dataset.formHaarHart
                     : koeder.indexOf('weit') > -1 ? root.dataset.formHaarWeit
                     : root.dataset.formHaar;

      var slots = [
        { formen: root.dataset.formPlatz, label: root.dataset.rollePlatz },
        { formen: haarFormen, label: root.dataset.rolleHaar }
      ];
      if (antworten.ziel === 'session') slots.reverse();

      /* Truebes Wasser nimmt die Sicht, Stroemung verduennt und traegt ab — beide Male
         muss der Reiz ueber den Geruch kommen. */
      var braucht_extra = wasser.indexOf('truebe') > -1 || wasser.indexOf('stroemung') > -1;
      if (braucht_extra && root.dataset.formExtra) {
        slots.push({ formen: root.dataset.formExtra, label: root.dataset.rolleExtra });
      }

      var vergeben = [];
      slots.forEach(function (slot) {
        var produkt = ersteForm(sorteEl, slot.formen, vergeben);
        if (!produkt) return;
        vergeben.push(produkt);
        var rolle = produkt.querySelector('[data-produkt-rolle]');
        if (rolle) rolle.textContent = slot.label || '';
        produkt.hidden = false;
        behaelter.appendChild(produkt);
      });
    }

    /* ---------- Report ---------- */
    function bauReport() {
      personalisieren();

      var karten = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-karte]'));
      var pool = root.querySelector('[data-quiz-pool]');
      var haupt = root.querySelector('[data-quiz-haupt]');
      var dazu = root.querySelector('[data-quiz-dazu]');
      if (!pool || !haupt || !dazu) return;

      [haupt, dazu].forEach(function (slot) {
        Array.prototype.slice.call(slot.children).forEach(function (kind) { pool.appendChild(kind); });
      });
      root.querySelectorAll('[data-produkt]').forEach(function (pr) {
        pr.hidden = true;
        var rolle = pr.querySelector('[data-produkt-rolle]');
        if (rolle) rolle.textContent = '';
      });

      var sortiert = karten
        .map(function (k) { return { el: k, p: punkte(k), b: bestseller(k) }; })
        .sort(function (a, b) { return b.p - a.p || b.b - a.b; });

      sortiert.forEach(function (eintrag, i) {
        eintrag.el.hidden = i > 2;
        if (i === 0) { baueSetup(eintrag.el); haupt.appendChild(eintrag.el); }
        else if (i <= 2) { dazu.appendChild(eintrag.el); }
      });

      /* Preisanker am CTA: der Knopf nennt die Setup-Summe, die Zeile darunter
         die heutige Ersparnis — gleiche Ansprache wie im Warenkorb-Drawer.
         Gefiltert wird exakt wie im ATC-Handler, damit Summe und Warenkorb
         nie auseinanderlaufen. */
      var summe = 0;
      var altSumme = 0;
      haupt.querySelectorAll('[data-produkt]:not([hidden])').forEach(function (zeile) {
        if (zeile.dataset.verfuegbar !== 'true') return;
        var preis = parseInt(zeile.dataset.preisCents, 10) || 0;
        summe += preis;
        altSumme += parseInt(zeile.dataset.altCents, 10) || preis;
      });
      var summeEl = root.querySelector('[data-quiz-atc-summe]');
      if (summeEl) summeEl.textContent = summe > 0 ? '— ' + geld(summe) : '';
      var ersparnisEl = root.querySelector('[data-quiz-ersparnis]');
      if (ersparnisEl) {
        var ersparnis = altSumme - summe;
        ersparnisEl.hidden = ersparnis <= 0;
        if (ersparnis > 0) ersparnisEl.textContent = 'Du sparst heute ' + geld(ersparnis) + ' auf dein Setup.';
      }

      /* Steckbrief */
      setzeText('[data-report-name]', antworten.name || 'dein Wasser');
      setzeText('[data-report-typ]', labelVon('typ'));
      setzeText('[data-report-rhythmus]', labelVon('rhythmus'));
      setzeText('[data-report-ziel]', labelVon('ziel'));

      /* Kategorie-Status: ‚Achtung‘ wenn etwas gewaehlt wurde, sonst ‚passt‘ */
      ['platz', 'koeder', 'wasser'].forEach(function (feld) {
        var chip = root.querySelector('[data-report-status="' + feld + '"]');
        if (!chip) return;
        var liste = antworten[feld] || [];
        var offen = liste.length > 0 && liste.indexOf('keins') === -1;
        chip.classList.toggle('is-achtung', offen);
        var text = chip.querySelector('[data-report-status-text]');
        if (text) text.textContent = offen ? (liste.length + ' Punkt' + (liste.length > 1 ? 'e' : '')) : 'passt';
      });

      /* Durchmesser: gross haelt Weissfisch fern und fliegt weiter, klein bringt im
         Kalten und auf die Schnelle mehr Bisse. Das Koeder-Problem wiegt schwerer. */
      var koeder2 = antworten.koeder || [];
      var wasser2 = antworten.wasser || [];
      var gross = ['weissfisch', 'krebse', 'weit'].some(function (k) { return koeder2.indexOf(k) > -1; });
      var klein = wasser2.indexOf('kalt') > -1 || antworten.dauer === 'kurz';
      var stufe = gross ? 'gross' : klein ? 'klein' : 'normal';
      var d = root.querySelector('[data-report-durchmesser]');
      if (d) d.textContent = d.dataset[stufe] || '';

      /* Menge haengt an der Sessiondauer, nicht am Rhythmus — wer laenger bleibt, fuettert mehr. */
      var m = root.querySelector('[data-report-menge]');
      if (m) m.textContent = m.dataset[antworten.dauer || 'tag'] || '';

      var z = root.querySelector('[data-report-zusatz]');
      if (z) {
        var zusaetze = [];
        if (antworten.groesse === 'gross' && z.dataset.gross) zusaetze.push(z.dataset.gross);
        if (wasser2.indexOf('kalt') > -1 && z.dataset.kalt) zusaetze.push(z.dataset.kalt);
        z.textContent = zusaetze.join(' ');
        z.hidden = zusaetze.length === 0;
      }
    }

    function setzeText(sel, wert) {
      var el = root.querySelector(sel);
      if (el) el.textContent = wert;
    }
    function labelVon(feld) {
      var wert = antworten[feld];
      if (!wert) return '—';
      var knopf = root.querySelector('[data-quiz-single="' + feld + '"][data-quiz-wert="' + wert + '"]');
      return knopf ? (knopf.dataset.quizLabel || knopf.textContent.trim()) : wert;
    }

    /* ---------- Setup in den Warenkorb (Pauls Auftrag 21.08.) ----------
       Ein Knopf legt alle sichtbaren Setup-Produkte auf einmal, der kleine
       Plus je Zeile ein einzelnes. Der Add-Request bringt die Drawer-Sections
       gleich mit; renderContents oeffnet Dawns Warenkorb — die Ansage bleibt
       dabei stehen, der Kunde verliert sein Ergebnis nicht. */
    function inDenWarenkorb(items, knopf) {
      if (!items.length || knopf.disabled) return;
      knopf.disabled = true;
      var status = root.querySelector('[data-quiz-atc-status]');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble' })
      })
        .then(function (antwort) {
          if (!antwort.ok) throw new Error('Quiz-ATC HTTP ' + antwort.status);
          return antwort.json();
        })
        .then(function (stand) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && stand.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents({ sections: stand.sections });
          }
          document.dispatchEvent(new CustomEvent('pykas:cart-updated'));
          if (status) {
            status.textContent = items.length > 1 ? '✓ Setup liegt im Warenkorb' : '✓ Liegt im Warenkorb';
            status.hidden = false;
          }
          knopf.disabled = false;
        })
        .catch(function (fehler) {
          console.error('[pykas-quiz] Warenkorb fehlgeschlagen', fehler);
          if (status) {
            status.textContent = 'Das hat nicht geklappt — versuch es nochmal.';
            status.hidden = false;
          }
          knopf.disabled = false;
        });
    }

    // Delegation statt Direktbindung: die Produktzeilen wandern beim
    // Reportbau zwischen Pool und Slots hin und her.
    root.addEventListener('click', function (event) {
      var einzeln = event.target.closest('[data-quiz-atc]');
      if (einzeln) {
        var zeile = einzeln.closest('[data-produkt]');
        var id = zeile && parseInt(zeile.dataset.variantId, 10);
        if (id) inDenWarenkorb([{ id: id, quantity: 1 }], einzeln);
        return;
      }
      var alle = event.target.closest('[data-quiz-atc-alle]');
      if (alle) {
        var haupt = root.querySelector('[data-quiz-haupt]');
        if (!haupt) return;
        var items = [];
        haupt.querySelectorAll('[data-produkt]:not([hidden])').forEach(function (zeile) {
          var id = parseInt(zeile.dataset.variantId, 10);
          if (id && zeile.dataset.verfuegbar === 'true') items.push({ id: id, quantity: 1 });
        });
        inDenWarenkorb(items, alle);
      }
    });

    personalisieren();
    zeige(0, true);
  }
})();
